$(document).ready(function() {
    $(".swatch_cls").click(function(){
    var swatch_level = $(this).attr("data-value");
      $(".swatch_cls").removeClass("active");
      $(this).addClass("active");
     $("#product-option-2").val(swatch_level).change();
  })
   var d_frequency = $('#product-option-1').val().toLowerCase();
   var d_level = $('#product-option-2').val();
   base_price_selected(d_frequency,d_level,1);
    $('#product-option-1, #product-option-2').on('change', function() {
      console.log("dfdf");
      var frequency = $('#product-option-1').val().toLowerCase();
      var level = $('#product-option-2').val();
      console.log('Selected Frequency:', frequency);
      console.log('Selected Level:', level);
      var product_1_month = $(".product_1_months."+frequency).find("select option[value='"+level+"']").attr("data_var_price");
      var product_3_month = $(".product_3_months."+frequency).find("select option[value='"+level+"']").attr("data_var_price");
      var product_6_month = $(".product_6_months."+frequency).find("select option[value='"+level+"']").attr("data_var_price");
      var product_12_month = $(".product_12_months."+frequency).find("select option[value='"+level+"']").attr("data_var_price");

      var product_1_month_compare = $(".product_1_months."+frequency).find("select option[value='"+level+"']").attr("data_var_compare_price");
      var product_3_month_compare = $(".product_3_months."+frequency).find("select option[value='"+level+"']").attr("data_var_compare_price");
      var product_6_month_compare = $(".product_6_months."+frequency).find("select option[value='"+level+"']").attr("data_var_compare_price");
      var product_12_month_compare = $(".product_12_months."+frequency).find("select option[value='"+level+"']").attr("data_var_compare_price");
      // You can perform additional actions with the selected values here
      console.log($(".product_12_months."+frequency).find("select option[value='"+level+"']"));
      $(".m-product-3 .monthly_price .money").text(product_3_month);
      $(".m-product-6 .monthly_price .money").text(product_6_month);
      $(".m-product-12 .monthly_price .money").text(product_12_month);
      
      console.log(product_3_month_compare,"---product_3_month_compare");
      console.log(product_6_month_compare,"---product_6_month_compare",product_12_month_compare,"----product_12_month_compare");
      
      if (product_3_month_compare !== undefined && product_3_month_compare !== null) {
        // Remove the dollar sign and convert to a number
        var compare_replace = parseFloat(product_3_month_compare.replace("$", ""));
        var price_replace = parseFloat(product_3_month.replace("$", ""));
        
        // Calculate discount
        var discount = compare_replace - price_replace;
        console.log(discount,"---discount---",compare_replace,"--compare_replace--",price_replace)
        var discount_percent = (discount / compare_replace) * 100;

        // Display the discount percentage
        if (discount_percent > 0) {
            console.log(discount_percent.toFixed(1) + '% off'); // Round to 1 decimal place
            $(".m-product-3 .monthly_price .discount").text('('+discount_percent.toFixed(2) +'% off)')
        } else {
            console.log('No discount');
           $(".m-product-3 .monthly_price .discount").text("");
          
        }
      }else{
         $(".m-product-3 .monthly_price .discount").text("");
      }

       if (product_6_month_compare !== undefined && product_6_month_compare !== null) {
        // Remove the dollar sign and convert to a number
        var compare_replace = parseFloat(product_6_month_compare.replace("$", ""));
        var price_replace = parseFloat(product_6_month.replace("$", ""));
        
        // Calculate discount
        var discount = compare_replace - price_replace;
        console.log(discount,"---discount---",compare_replace,"--compare_replace--",price_replace)
        var discount_percent = (discount / compare_replace) * 100;

        // Display the discount percentage
        if (discount_percent > 0) {
            console.log(discount_percent.toFixed(1) + '% off'); // Round to 1 decimal place
            $(".m-product-6 .monthly_price .discount").text('('+discount_percent.toFixed(2) +'% off)')
        } else {
            console.log('No discount');
           $(".m-product-6 .monthly_price .discount").text("");
          
        }
      }else{
         $(".m-product-6 .monthly_price .discount").text("");
      }

      if (product_12_month_compare !== undefined && product_12_month_compare !== null) {
        // Remove the dollar sign and convert to a number
        var compare_replace = parseFloat(product_12_month_compare.replace("$", ""));
        var price_replace = parseFloat(product_12_month.replace("$", ""));
        
        // Calculate discount
        var discount = compare_replace - price_replace;
        var discount_percent = (discount / compare_replace) * 100;

        // Display the discount percentage
        if (discount_percent > 0) {
            console.log(discount_percent.toFixed(1) + '% off'); // Round to 1 decimal place
            $(".m-product-12 .monthly_price .discount").text('('+discount_percent.toFixed(2) +'% off)')
        } else {
            $(".m-product-12 .monthly_price .discount").text("");
        }
      }else{
         $(".m-product-12 .monthly_price .discount").text("");
      }

      var data_month_sel = $(".mothly-product.active").attr("data-month");
       if(data_month_sel !== undefined){
         var data_month =  data_month_sel;
       }else{
         var data_month = 1;
       }
       
      /// 1 month
    base_price_selected(frequency,level,data_month);
      /// end one month
      $(".m-product-3 .monthly_price .compare_price").text(product_3_month_compare || '');
      $(".m-product-6 .monthly_price .compare_price").text(product_6_month_compare || '');
      $(".m-product-12 .monthly_price .compare_price").text(product_12_month_compare || '');
  });
    $(".mothly-product").click(function(){
        var frequency = $('#product-option-1').find(":selected").val().toLowerCase();
      var level = $('#product-option-2').find(":selected").val();
      var data_month = $(this).attr("data-month");
       if (!$(this).hasClass("active")) {
        // Remove active class from all elements
            $(".mothly-product").removeClass("active");
            // Add active class to the clicked element
            $(this).addClass("active");
         base_price_selected(frequency,level,data_month);
        } else {
            // Remove active class from the clicked element if it is already active
            $(this).removeClass("active");
           base_price_selected(frequency,level,1);
        }
    
      
      
    });
  
  function base_price_selected(frequency,level,data_month){
     var product_price = $(".product_"+data_month+"_months."+frequency).find("select option[value='"+level+"']").attr("data_var_price");
      var product_compare = $(".product_"+data_month+"_months."+frequency).find("select option[value='"+level+"']").attr("data_var_compare_price");
      
      $(".bundel-price .price.price--sale .money").text(product_price || '');
      $(".bundel-price .compare-at-price .money").text(product_compare || '');
      console.log(product_compare, "---product_compare");
      
      if (product_compare !== undefined && product_price !== undefined) {
          var product_compare_replace = parseFloat(product_compare.replace("$", ""));
          var product_price_replace = parseFloat(product_price.replace("$", ""));
      
          var product_discount = product_compare_replace - product_price_replace;
          var product_discount_percent = (product_discount / product_compare_replace) * 100;
      
          var sale_save = 'You Save <span class="per">' + Math.round(product_discount_percent) + '%</span> (<span class="money">$' + product_discount.toFixed(2) + '</span>)';
        if(product_discount != 0)  {
            $(".bundel-price .sale.savings").html(sale_save);
        }else{
           $(".bundel-price .sale.savings").html('');
        }
      
      }else{
        $(".bundel-price .sale.savings").html('');
      }
  }
      $(".bundle_add_to_cart").click(function() {
          var monthly = $(".option-frequency").val().toLowerCase();
          var level = $(".option-level").val();
          var buy_month = $(".mothly-product.active").attr("data-month");
          var giftCheckbox = $('input.gift-check');
          var isGiftChecked = giftCheckbox.prop("checked");

          console.log(monthly, "----monthly", "---level---", level, buy_month, "---isGiftChecked--", isGiftChecked);
       
          if(typeof buy_month !== "undefined"){
          var variant_id = $(".product_" + buy_month + "_months." + monthly).find("select option[value='" + level + "']").attr("data_var_id");
          var selling_plan = $(".product_" + buy_month + "_months." + monthly).find(".selling_plan").val();
          }else{
           var variant_id = $(".product_1_months." + monthly).find("select option[value='" + level + "']").attr("data_var_id");
           var selling_plan = $(".product_1_months." + monthly).find(".selling_plan").val();
          }
          console.log("variant_id--", variant_id, "--selling_plan--", selling_plan);

          // If the gift option is checked, add the gift item to the items array
          if (isGiftChecked) {
              if(typeof buy_month !== "undefined"){
              var gift_variant_id = $(".product_" + buy_month + "_months." + monthly + "-gift").find("select option[value='" + level + "']").attr("data_var_id");
              var gift_selling_plan = $(".product_" + buy_month + "_months." + monthly + "-gift").find(".selling_plan").val();
              }else{
                 var gift_variant_id = $(".product_1_months." + monthly + "-gift").find("select option[value='" + level + "']").attr("data_var_id");
                 var gift_selling_plan = $(".product_1_months." + monthly + "-gift").find(".selling_plan").val();
              }
              var gift_message = $(".gift-textarea textarea").val();

              console.log("gift_variant_id--", gift_variant_id, "--gift_selling_plan--", gift_selling_plan);

            data = {
                "id": gift_variant_id,
                "quantity": 1,
              "selling_plan": gift_selling_plan,
                "properties[gift_message]": gift_message,

            };
        }else{
            data = {
                "id": variant_id,
                "quantity": 1,
              "selling_plan": selling_plan
            };
        }
      console.log(data, '<<<<<<dataa')

        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function(response) {
                console.log("succes added to cart");
                console.log(response);
                window.location.href = '/cart';
            }
        });
        //window.location = '/checkout';
        // stepFour();


      });
       $('input.gift-check').click(function() {
          if ($(this).is(':checked')) {
              $(this).attr('checked', 'checked');  // Add checked attribute
          } else {
              $(this).removeAttr('checked');       // Remove checked attribute
          }
        if ($(this).prop("checked")) {
            $(".gift-textarea").show();
        } else {
            $(".gift-textarea").hide();
        }
    });
  });
